import type * as React from 'react';

import { PageLayoutOptionsCoverSize } from '@gitbook/hive-core';
import {
    Description,
    FieldGroup,
    SegmentedControl,
    type SegmentedControlOption,
    Switch,
} from '@gitbook/spine-react';

import type { PageLayoutOptionsProps } from './types';

const coverImageLayoutOptions: Array<SegmentedControlOption<PageLayoutOptionsCoverSize>> = [
    { value: PageLayoutOptionsCoverSize.Hero, label: 'Hero' },
    { value: PageLayoutOptionsCoverSize.Full, label: 'Full' },
];

/**
 * Options to configure cover images on a page.
 * Through this, we can SegmentedControl cover image visibility and size.
 */
export function PageOptionsCoverImage(props: PageLayoutOptionsProps): React.ReactElement {
    const { pageOptions, setPageOptionsUpdate } = props;

    return (
        <div className="flex flex-1 flex-col gap-2">
            <FieldGroup orientation="horizontal">
                <Description>Cover image</Description>
                <Switch
                    value={!!pageOptions.layoutOptions.cover}
                    onValueChange={(value) => {
                        setPageOptionsUpdate({
                            layoutOptions: {
                                ...pageOptions.layoutOptions,
                                cover: value,
                            },
                        });
                    }}
                />
            </FieldGroup>
            <FieldGroup orientation="horizontal">
                <Description>Size</Description>
                <SegmentedControl
                    options={coverImageLayoutOptions}
                    active={pageOptions.layoutOptions.coverSize}
                    onChange={(value) =>
                        setPageOptionsUpdate({
                            layoutOptions: {
                                ...pageOptions.layoutOptions,
                                coverSize: value,
                            },
                        })
                    }
                />
            </FieldGroup>
        </div>
    );
}
